import { Component } from 'react';
import PropTypes from 'prop-types';
import AdsAudienceMembershipActionMetadata from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import AdsAudienceMembershipActionDetail from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
export default class AdsAudienceMembershipActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(AdsAudienceMembershipActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
AdsAudienceMembershipActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(AdsAudienceMembershipActionMetadata).isRequired,
  actionLabel: PropTypes.node
};